import React from 'react'

const InterviewReport = () => {
  return (
    <div>InterviewReport</div>
  )
}

export default InterviewReport